import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpEvent } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { StorageConst } from '../../constants/storage.const';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HttpClientService {
    baseURL: string = environment.baseURL;
    baseURL2: string = environment.baseURL2;
    currentLocationURL: string = environment.currentLocationURL;
    phpBaseURL: string = environment.basePHPURL;
    apiPHPURLv2: string = environment.apiPHPURLv2;
    phpBasev3:string = environment.apiPHPURLv3;

    constructor(
        private httpClient: HttpClient,
        private localStorageService: LocalStorageService
    ) {}

    private getHeaderAuth() {
        const token = this.localStorageService.getKey(StorageConst.access_token);
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            }),
        };
        return httpOptions;
    }

    private getHeaderBasicAuth() {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Basic ' + btoa('akorn:akorn'),
            }),
        };
        return httpOptions;
    }

    private getHeaderAuthForAccessToken() {
        const token = this.localStorageService.getKey('access_token');
        const httpOptions = {
            headers: new HttpHeaders({
                'username': 'crizac',
                'password': 'crizac123'
            }),
        };
        return httpOptions;
    }

    private  getHeaderAuthUpload() {
        const token = this.localStorageService.getKey(StorageConst.access_token);
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
            }),
        };
        return httpOptions;
    }

    private getHeaderBasicAuthUpload() {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: 'Basic ' + btoa('akorn:akorn'),
            }),
        };
        return httpOptions;
    }
    private getHeaderAuthForWorldPay(customerId) {
        const token = this.localStorageService.getKey(StorageConst.access_token);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
            'customer_id':customerId
        });
        return { headers };
    }

    private getPasswordResetAuth(token:string) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            }),
        };
        return httpOptions;
    }

    public getResetPasswordAuth(url: string, payload: any) {
        let httpOptions = this.getPasswordResetAuth(payload.token);
        delete payload.token;
        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }
    private getDataWithBasicAuthv2DirectPDF(username: string, password: string) {
        const basicAuth = btoa(`${username}:${password}`);
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: `Basic ${basicAuth}`,
                // 'X-Bypass-Token-Replacement': 'true',
                // username: 'crizac', // Send username in headers
                // password: 'crizac',
            }),
            responseType: 'arraybuffer' as 'json', // Specify response type for PDF
        };

        return httpOptions;
    }

    public get(url: string, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.get<unknown>(
            `${this.baseURL}${url}`,
            httpOptions
        );
    }

    public post(url: string, payload: unknown, options: any = {}, isBasicAuth: boolean = false): Observable<any> {
        let httpOptions = this.getHeaderBasicAuth();
        
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
    
        // Merge the passed options (which includes query params) with httpOptions
        httpOptions = { ...httpOptions, ...options };
    
        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }

    public postAccessToken(url: string, payload: unknown) {
        let httpOptions = this.getHeaderAuthForAccessToken();
        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }

    public postForWorldPay(url: string, payload: unknown, customerId: string) {
        let httpOptions = this.getHeaderAuthForWorldPay(customerId);

        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }
    

    public put(url: string, payload: unknown, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.put<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }

    public patch(url: string, payload: unknown, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.patch<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }

    public delete(url: string, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.delete<unknown>(
            `${this.baseURL}${url}`,
            httpOptions
        );
    }

    public upload(url: string, payload: unknown, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuthUpload();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuthUpload();
        }
        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }
    public uploadpdf<T>(
        url: string,
        payload: unknown,
        isBasicAuth: boolean = false,
        responseType: 'json' | 'blob' = 'json'
    ): Observable<HttpEvent<T>> {
        let httpOptions: any = isBasicAuth
            ? this.getHeaderBasicAuthUpload()
            : this.getHeaderAuthUpload();
        httpOptions = {
            ...httpOptions,
            responseType: responseType as 'json' | 'blob',
            observe: 'events',
        };
        return this.httpClient.post<T>(`${this.baseURL2}${url}`, payload, httpOptions);
    }

    public getLocation() {
        return this.httpClient.get<unknown>(`${this.currentLocationURL}`);
    }

    public csv(url: string) {
        let httpOptions = this.getHeaderAuthUpload();
        return this.httpClient.get(`${this.baseURL}${url}`, {...httpOptions, responseType: 'blob' });
    }



    // PHP API
    public getPhp(url: string, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        console.log(`${this.phpBaseURL}${url}`)
        return this.httpClient.get<unknown>(
            `${this.phpBaseURL}${url}`,
            httpOptions
        );
    }

     //spclpostforautologin
     public autologinpost(url: string, payload: unknown, headers) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Basic ' + btoa('akorn:akorn'),
                'username': headers?.username,
                'password': headers?.password
            }),
        };
        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }

    //spclpostforautologinforadmin
    public autologinpostforadmin(url: string, payload: any, headers) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Basic ' + btoa('akorn:akorn'),
                "userName": headers.username,
                "password": headers.password
            }),
        };
        return this.httpClient.post<unknown>(
            `${this.baseURL}${url}`,
            payload,
            httpOptions
        );
    }

    public postPhp(url: string, payload, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.post<unknown>(
            `${this.phpBaseURL}${url}`,
            payload,
            httpOptions
        );
    }

    private getHeaderBasicAuthCommission() {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: 'Basic ' + btoa('akorn:akorn'),
            }),
        };
        return httpOptions;
    }

    // PHP API
    public getPhpForCommission(url: string, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuthCommission();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderBasicAuthCommission();
        }
        let host = this.phpBaseURL.replace(/\/api_mongo\/?$/, "");
        return this.httpClient.get<unknown>(
            `${host}${url}`,
            httpOptions
        );
    }

    public postPhpWithOutAgent(url: string, payload, isBasicAuth: boolean = false) {
        let httpOptions = this.getHeaderBasicAuth();
        if (!isBasicAuth) {
            httpOptions = this.getHeaderAuth();
        }
        return this.httpClient.post<unknown>(
            `${this.apiPHPURLv2}${url}`,
            payload,
            httpOptions
        );
    }
    public postPhpForPDF(url: string, payload, isBasicAuth: boolean = false) {
        let httpOptions = this.getDataWithBasicAuthv2DirectPDF('crizac', 'crizac');;
        if (!isBasicAuth) {
            httpOptions = this.getDataWithBasicAuthv2DirectPDF('crizac', 'crizac');;
        }
        return this.httpClient.post<unknown>(
            `${this.phpBasev3}${url}`,
            payload,
            httpOptions
        );
    }

}
